import smoothscroll from "smoothscroll-polyfill"

smoothscroll.polyfill()

const scrollUpElement = document.getElementById("c-scroll-up")

if (scrollUpElement !== null) {
  const scrollUpSearchButton = scrollUpElement.querySelector<HTMLElement>('.c-scroll-up__search-button');
  const scrollUpSearchClose = scrollUpElement.querySelector<HTMLElement>('.c-scroll-up__search-close');
  const scrollUpButton = scrollUpElement.querySelector<HTMLElement>('.c-scroll-up__button');
  const scrollUpSearchForm = scrollUpElement.querySelector<HTMLElement>('.c-scroll-up__search-form');
  const offsetFromTop = Number(scrollUpElement.getAttribute("data-offset-from-top")) ?? 100 // if not set default is 100px

  const isInLimit = () => document.body.scrollTop > offsetFromTop || document.documentElement.scrollTop > offsetFromTop

  const scrollHandle = () => {
    scrollUpElement.classList.toggle("--active", isInLimit())
  }

  const scrollTop = () => {
    window.scrollTo({top: 0, behavior: "smooth"})
  }

  window.addEventListener('scroll', scrollHandle, {passive: true})

  scrollUpButton?.addEventListener("click", scrollTop)

  scrollUpSearchButton?.addEventListener('click', () => {
    scrollUpElement.classList.add('--search-open');
    const searchInput = scrollUpSearchForm.querySelector<HTMLInputElement>('.f-search__input input')
    searchInput?.focus();
  })

  scrollUpSearchClose?.addEventListener('click', () => {
    scrollUpElement.classList.remove('--search-open');
  })
}
